import { render, staticRenderFns } from "./header_menu_phone.vue?vue&type=template&id=1c3c7e24&scoped=true"
import script from "./header_menu_phone.vue?vue&type=script&lang=js"
export * from "./header_menu_phone.vue?vue&type=script&lang=js"
import style0 from "./header_menu_phone.vue?vue&type=style&index=0&id=1c3c7e24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c7e24",
  null
  
)

export default component.exports